import { AxiosError } from 'axios'
import { useQuery, UseQueryOptions } from 'react-query'

import { ICompany } from '@monorepo/interfaces'
import { useApi } from '../useApi'

export function useOfficesList<TData = ICompany[]>(
  options?: UseQueryOptions<ICompany[], AxiosError, TData>
) {
  const { fetchOffices } = useApi()

  return useQuery('fetchOffices', fetchOffices, {
    refetchOnWindowFocus: false,
    ...options,
  })
}
